import { Component, OnInit, Input } from '@angular/core';
import { IoService } from '../../../services/io/io.service';
import { LocationService } from '../../../services/location/location.service';

@Component({
  selector: 'app-importer',
  templateUrl: './importer.component.html',
  styleUrls: ['./importer.component.scss']
})
export class ImporterComponent implements OnInit {

  @Input() importType: string = '';
  expanded: boolean = false;

  constructor(
    private ioService: IoService,
    private locationService: LocationService
  ) { }

  ngOnInit(): void {
    // this.toggleImporter();
  }

  toggleImporter() {
    this.expanded = !this.expanded;
  }

  onImportFileChange(event: any) {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this.ioService.upload('import/upload', {
        locationId: this.locationService.getActiveLocation()._id,
        importType: this.importType
      }, file).subscribe(event => {
        console.log(event);
        let uploadEvent: any = event;
        if (uploadEvent.body && uploadEvent.body.importId) {
          this.loadImportPreview(uploadEvent.body.importId);
        }
      });
    }
  }

  async loadImportPreview(importId: string) {

    let previewData: any = await this.ioService.post('import/getImportPreview', {
      importId: importId
    });

    console.log('Import Preview Data:', previewData);
  }

}
